import { denar } from '../oblika/oblika';

/** Stanje naročnine (StanjeNarocnine s strežnika) → oznaka in barva značke. */
export const STANJA_NAROCNINE: Record<string, { oznaka: string; barva: string; polno?: boolean }> = {
  BREZ_OMEJITVE: { oznaka: 'brez omejitve', barva: 'gray' },
  AKTIVNO: { oznaka: 'plačano', barva: 'green' },
  POTEKA: { oznaka: 'poteka', barva: 'yellow' },
  ZAMUDA: { oznaka: 'zamuda', barva: 'orange' },
  ZAKLENJENO: { oznaka: 'zaklenjeno', barva: 'red' },
  DOKONCNO: { oznaka: 'dokončen zaklep', barva: 'red', polno: true },
  ZA_IZBRIS: { oznaka: 'za izbris', barva: 'dark', polno: true },
};

/** Stanja, v katerih je dostop zaprt (kot StanjaNarocnin.ZAKLENJENA na strežniku). */
export const ZAKLENJENA = ['ZAKLENJENO', 'DOKONCNO', 'ZA_IZBRIS'];

/** Vrsta gibanja točk → besedilo. */
export const VRSTE_GIBANJ: Record<string, string> = {
  NAKAZILO: 'Nakazilo',
  BONUS: 'Bonus',
  STROSEK: 'Strošek obdelave',
  ROCNO: 'Ročno',
  NAROCNINA: 'Naročnina',
  PONOVNI_VKLOP: 'Ponovni vklop',
  RAZSIRITEV: 'Razširitev paketa',
  ZAHTEVEK: 'Zahtevek',
  AI: 'Umetna inteligenca',
};

/** Opis gibanja: znesek nakazila in komentar (npr. »49,90 € · Plačnik d.o.o.«). */
export function opisGibanja(znesek: number | undefined | null, komentar: string | undefined | null): string {
  return [znesek != null ? `${denar(znesek)} €` : '', komentar ?? ''].filter(Boolean).join(' · ');
}

/** »1 mesec«, »2 meseca«, »3 mesece«, »5 mesecev« (slovenska dvojina in množina). */
export function meseci(n: number): string {
  const s = n % 100;
  const beseda = s === 1 ? 'mesec' : s === 2 ? 'meseca' : s === 3 || s === 4 ? 'mesece' : 'mesecev';
  return `${n} ${beseda}`;
}
